// Styles for page-specific tapestry components
// Ref: https://planningcenter.github.io/tapestry-react/page

export default {
  pageBody: {
    backgroundColor: "inherit",
    paddingTop: "14px",
  },
  pageTitle: {
    lineHeight: "32px",
  },
}
